import { render, staticRenderFns } from "./oldManList.vue?vue&type=template&id=c90f15ba&scoped=true&"
import script from "./oldManList.vue?vue&type=script&lang=js&"
export * from "./oldManList.vue?vue&type=script&lang=js&"
import style0 from "./oldManList.vue?vue&type=style&index=0&id=c90f15ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f15ba",
  null
  
)

export default component.exports